import React, {useState} from 'react'
import {Link} from 'react-router-dom'
import MenuNumber from '../../panel-admin/common/helpers/MenuNumber'

function  Menu(props) {
  const [isOpen, setIsOpen] = useState(false);
  const toggle = () => {
    setIsOpen(!isOpen);
  }

  const displayNumber = (title) => {
    switch(title) {
    case 'Draft productions':
      return <MenuNumber number={props.dashboardData.DraftProductionsNumber} status={"danger"}/>;
    case 'Pending':
      return <MenuNumber number={props.dashboardData.PendingProfilesNumber} status={"danger"}/>;
    case 'Pending requests':
      return <MenuNumber number={props.dashboardData.PendingClientAccountsNumber} status={"danger"}/>;
    default:
      return '';
    }
  }

    let items = props.items
    if (items.items.length === 0) {
      return (
        <li>
          <Link
            to={items.url}
            className="btn btn-default btn-flat btn-sidebar btn-sidebar-1">
            <i className="material-icons">{items.icon}</i>
            <span className="title">{items.title}
              {props.dashboardData !== null && displayNumber(items.title)}
            </span>
            {items.badge && (
              <span className={`ml-auto ${items.badge.className}`}>
                {items.badge.title}
              </span>
            )}
          </Link>
        </li>
      )
    } else {
      return (
        <li>
          <a
            className={
              isOpen
                ? 'btn btn-default btn-flat btn-sidebar btn-sidebar-1 has-children is-open'
                : 'btn btn-default btn-flat btn-sidebar btn-sidebar-1 has-children'
            }
            onClick={toggle}>
            <i className="material-icons">{items.icon}</i>
            <span className="title">{items.title}</span>
            {items.badge && (
              <span className={`ml-auto ${items.badge.className}`}>
                {items.badge.title}
              </span>
            )}
          </a>
          <ul className="list-unstyled">
            {items.items.map((item, k) => (
              <li key={k}>
                <Link
                  to={item.url}
                  className="btn btn-default btn-flat btn-sidebar btn-sidebar-2">
                  <i className="material-icons">{item.icon}</i>
                  <span className="title">{item.title}</span>
                </Link>
              </li>
            ))}
          </ul>
        </li>
      )
    }

}

export default Menu
